import { Injectable } from "@angular/core";
import { Http, RequestMethod, RequestOptions, Response,Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { TranslateLoader } from "@ngx-translate/core";
import { environment } from './../../../environments/environment';

@Injectable()
export class AppTranslateService implements TranslateLoader {

    constructor(private http: Http) {
    }

    /**
     * To get the translations of selected language file
     * @param  {any} language
     * @returns Observable
     */
    getTranslation(language: any): Observable<any> {
        let url:any;
        let options:any;
        let isChargebeeLanguage=language!=null && language.isChargebeeLanguage && language.isChargebeeLanguage===true ?true:false;
        if(language && language.isChargebeeLanguage){
            language=language.code || 'en-us';
        }
        else{
            language = language || 'en-us';
        }
        try {
            language = JSON.parse(language);
        } catch (e) {
            language = language;
        }
        if(isChargebeeLanguage){
            url = environment.cdnURL + "/portals/customercare/chargebee/translations/" + language.toLowerCase() + '.json';
        }
        else{
            url = environment.cdnURL + "/portals/customercare/template1/json/" + language.toLowerCase() + '.json';
        }
        const headers = new Headers();
        headers.append('termsAndCondition', 'true');
        options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        return this.http
            .get(url,options)
            .map((res: Response) => res.json())
            .catch((error: any) => {
                return this.fallbackToDefaultLanguage();
            });
    }

    /**
     * if selected language translation file is not found then use default lang file
     */
    fallbackToDefaultLanguage() {
        const defaultLanguage = "en-us";
        let options:any;
        const headers = new Headers();
        headers.append('termsAndCondition', 'true');
        options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        return this.http
            .get(environment.cdnURL + "/portals/customercare/template1/json/" + defaultLanguage + ".json",options)
            .map((res: Response) => res.json())
            .catch((error: any) => {
                return Observable.throw(error.message || error);
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/translations/services/app-translation.service.ts